import React__default from 'react';
import isFunction from 'lodash/isFunction';

var DIRECTION_CLASSNAME = {
  col: 'flex-col',
  'col-reverse': 'flex-col-reverse',
  row: 'flex-row',
  'row-reverse': 'flex-row-reverse'
};
var ALIGN_ITEMS_CLASSNAME = {
  baseline: 'items-baseline',
  center: 'items-center',
  end: 'items-end',
  start: 'items-start',
  stretch: 'items-stretch'
};
var JUSTIFY_CONTENT_CLASSNAME = {
  around: 'justify-around',
  between: 'justify-between',
  center: 'justify-center',
  end: 'justify-end',
  evenly: 'justify-evenly',
  start: 'justify-start'
};
var joinChildren = function joinChildren(children, divider) {
  var childrenArray = React__default.Children.toArray(children);
  return childrenArray.reduce(function (acc, child, index) {
    acc.push(child);
    if (index < childrenArray.length - 1) {
      acc.push( /*#__PURE__*/React__default.cloneElement(isFunction(divider) ? divider(index) : divider, {
        key: "divider-" + index
      }));
    }
    return acc;
  }, []);
};

export { ALIGN_ITEMS_CLASSNAME, DIRECTION_CLASSNAME, JUSTIFY_CONTENT_CLASSNAME, joinChildren };
//# sourceMappingURL=utils.js.map
